export type ProfitTypeStatusTypes = "a" | "i" | "x";

export enum ProfitTicketBalanceReleaseTypeEnum {
  INSTANT = "instant", // release the ticket insta (don't create queue)
  DAYS_AFTER_SALE = "days_after_sale", // schedule on cash releaseAt
  RAFFLE_FINISHED = "raffle_finished", // create the cash_raffle_ticket_release_queue (on raffle/campaign finish)
} // inside the profit data

export type ProfitBalanceRelaseTypeTypes =
  `${ProfitTicketBalanceReleaseTypeEnum}`;

  export enum CashRaffleTicketReleaseQueueStatusEnum {
  PENDING = "p",
  DONE = "d",
  FAILED = "f",
  CANCELED = "c",
}

export type CashRaffleTicketReleaseQueueStatusTypes =
  `${CashRaffleTicketReleaseQueueStatusEnum}`;

export interface ICashRaffleTicketReleaseQueueDTO {
  id: number;
  // cash?: number;
  customer: number;
  // raffle?: number;
  raffleKey?: string;
  releaseType: ProfitBalanceRelaseTypeTypes;
  status?: CashRaffleTicketReleaseQueueStatusTypes;
  message?: string | null;
  processedAt?: Date | null;
  createdAt?: Date;
  updatedAt?: Date;
}
